
import React from "react";
import { Loader2 } from "lucide-react";
import { UserHeader } from "./UserHeader";

interface UserDetailsLoadingProps {
  onBack: () => void;
}

export const UserDetailsLoading: React.FC<UserDetailsLoadingProps> = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-[#F8F8F8] flex flex-col">
      <UserHeader userName="Chargement..." onBack={onBack} />
      <div className="flex items-center justify-center flex-1">
        <Loader2 className="h-8 w-8 text-[#BD1E28] animate-spin" />
      </div>
    </div>
  );
};
